import { useLocation, Navigate } from "react-router-dom";

export function IndexRedirect({ to }: { to: string }) {
  const { search } = useLocation();
  return <Navigate replace to={`${to}${search}`} />;
}
